import { css } from 'styled-components';
import {
  LinkedInImage,
  ProfileImage,
} from '../../../../components/ContactCard/ContactCard/styles';
import LazyImg from '../../../../components/LazyImg';
import spacing from '../../../../helpers/spacing';

export default css`
  ${LinkedInImage} {
    &${LazyImg} {
      border-radius: ${spacing(4)};
    }
  }

  ${ProfileImage} {
    &${LazyImg} {
      border-radius: ${spacing(4)};
    }
  }
`;
